const INTRA_COOKIE_NAME = 'intra_logged_in';
const INTRA_COOKIE_DAYS = 7;

export function setIntraLoggedIn(): void {
    const expires = new Date();
    expires.setDate(expires.getDate() + INTRA_COOKIE_DAYS);
    document.cookie = `${INTRA_COOKIE_NAME}=1; path=/; expires=${expires.toUTCString()}; SameSite=Lax`;
}

export function isIntraLoggedIn(): boolean {
    return document.cookie.includes(`${INTRA_COOKIE_NAME}=1`);
}

export function clearIntraLoggedIn(): void {
    document.cookie = `${INTRA_COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
